import { render, staticRenderFns } from "./BondDetailModal.vue?vue&type=template&id=2850fdf6&scoped=true"
import script from "./BondDetailModal.vue?vue&type=script&lang=js"
export * from "./BondDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2850fdf6",
  null
  
)

export default component.exports